
export const PublicSellerFactoriesQuery = new TypedDocumentString(`
    query PublicSellerFactoriesQuery($input: InputProductExtraShops!) {
  publicSellerFactories(input: $input) {
    ...ProductExtraFactory
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductExtraFactory on ProductExtraFactory {
  id
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  location {
    value
    __typename
  }
  document {
    _id
    __typename
  }
  __typename
}`, {"hash":"84b60d01236a1721b4650bafff294f0ff7962a039460aafd860ff8309b798e1d"});